import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { MultipleChoiseStyles } from './Style'
import { LightButton, Space, SpaceBetween } from 'styles/GlobalStyle'
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { ReactComponent as LinesIcon } from 'assets/icons/Lines.svg';
import { SvgIcon } from '@mui/material';
import { RenderFields } from 'components/Form';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { arrayPush, change } from 'redux-form';
import { CreateAssessmentDefContext } from './CreateAssessmentDefContext';
import { useQuery } from '@tanstack/react-query';
import { queryClient as qc } from 'keys'
import { getAssessmentDefFetch } from 'store/middlewares/assessment.crud';
import { isEmpty } from 'lodash';

const MultipleChoise = () => {
    const { categoryItem, question, currentItemIndex, setCurrentItemIndex } = useContext(CreateAssessmentDefContext)
    const { emptyItem, itemsKey } = categoryItem || {}
    const formValues = useSelector(state => state.form.createAssessmentDef?.values)

    const questions = formValues?.[itemsKey] || []

    const source_passage = formValues?.source_passage?.id || formValues?.source_passage

    const dispatch = useDispatch()

    const assessmentDef = useQuery({
        queryKey: [qc.assessmentDef, "assessment-def-view", formValues?.source_passage?.id || 0],
        queryFn: async () => {
            const { data } = await getAssessmentDefFetch({ id: source_passage })
            return data
        },
        enabled: !!source_passage
    })

    const addQuestion = useCallback(() => {
        setCurrentItemIndex(currentItemIndex => currentItemIndex + 1)
        dispatch(arrayPush('createAssessmentDef', itemsKey, emptyItem))
    }, [categoryItem])

    const goToPage = (index) => {
        setCurrentItemIndex(index)
    }

    const addNewAnswer = useCallback(() => {
        dispatch(arrayPush('createAssessmentDef', `${itemsKey}[${currentItemIndex}].answer_defs`, {}))
    }, [currentItemIndex])

    useEffect(() => {
        if (isEmpty(questions))
            dispatch(change('createAssessmentDef', categoryItem.itemsKey, [question]))
    }, [])

    useEffect(() => {
        setTimeout(() => {
            console.log("שאלות", questions);
        }, 3000);
    }, [questions])

    return (
        <MultipleChoiseStyles>
            <div className='create-assessment-title'>

            </div>
            <div className='wrap-pages'>
                <div className='pages'>
                    {questions?.map((question, index) =>
                        <div
                            className={`page ${index === currentItemIndex ? "selected-page" : ""}`}
                            key={question.id}
                            onClick={() => goToPage(index)}
                        >
                            {questions[index].text && questions[index].answer_defs[0].text &&
                                <div className='placeholder-lines'>
                                    <div className='placeholder-lines-icon'>
                                        <SvgIcon fontSize='small' component={LinesIcon} inheritViewBox />
                                    </div>
                                </div>
                            }
                            <div className='num-page'>
                                {`#${index + 1}`}
                            </div>
                        </div>
                    )}
                    <div>
                        <SpaceBetween />
                        <LightButton
                            variant="solid"
                            size="small"
                            label='הוספת שאלה'
                            action={addQuestion}
                            icon={<SvgIcon fontSize='small' component={AddIcon} inheritViewBox />}
                        />
                    </div>
                </div>
            </div>
            <div className='content'>
                <div className='question-section'>
                    <div className='title'>
                        {"שאלה"}
                        {`מספר ${currentItemIndex + 1}`}
                    </div>
                    <div>
                        <RenderFields
                            fields={[
                                {
                                    name: `${itemsKey}[${currentItemIndex}].text`,
                                    component: "input",
                                    placeholder: "מה השאלה?"
                                }
                            ]}
                        />
                    </div>
                    <Space />
                    <div className='title'>
                        <div>
                            {"תשובות"}
                            <div className='sub-title'>
                                {"סמנו וי בתשובה הנכונה"}
                            </div>
                        </div>
                        <div>
                            <LightButton
                                variant="solid"
                                size="small"
                                label={"הוספת תשובה"}
                                action={addNewAnswer}
                                icon={<SvgIcon fontSize='small' component={AddIcon} inheritViewBox />}
                            />
                        </div>
                    </div>
                    <div className='wrap-answers'>
                        <RenderFields
                            fields={[
                                {
                                    name: `${itemsKey}[${currentItemIndex}].answer_defs`,
                                    className: "wrap-answer",
                                    fields: [
                                        {
                                            name: "is_correct",
                                            component: "checkbox",
                                        },
                                        {
                                            // name: "answer-number",
                                            component: "custom",
                                            customComponent: ({ index }) =>
                                                <div className='num-answer'>{`${index + 1}.`}</div>
                                        },
                                        {
                                            className: "answer-input",
                                            name: "text",
                                            component: "input",
                                            placeholder: "מה התשובה?"
                                        }
                                    ]

                                }
                            ]}
                        />
                    </div>
                </div>
                {/* <div className='question-section view-assessment-def'>
                    <div className='title'>
                        {title}
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: text?.replace(/\r?\n/g, "<br />") }} />
                </div> */}
            </div>
        </MultipleChoiseStyles >
    )
}

export default MultipleChoise